import { render, staticRenderFns } from "./AppointmentRecords.vue?vue&type=template&id=755b7122&scoped=true"
import script from "./AppointmentRecords.vue?vue&type=script&lang=js"
export * from "./AppointmentRecords.vue?vue&type=script&lang=js"
import style0 from "./AppointmentRecords.vue?vue&type=style&index=0&id=755b7122&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755b7122",
  null
  
)

export default component.exports